/** @format */

import React, { useState, useRef, useEffect, useCallback } from "react";
import { RadioButton } from "primereact/radiobutton";
import DeclarationWrapper from "./Declaration.style";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { InputText } from "primereact/inputtext";
import OtherInfo from "_shared/OtherInfo/OtherInfo";
import { useDispatch } from "react-redux";
import { setHasExposure } from "redux/actions/commonActions";
import { FormatLineSpacing } from "@mui/icons-material";
import TooltipButton from "_shared/ToolTip/ToolTip";
import { BUSINESS_LINE_COLORS } from "helpers/utils";
import { Accordion, AccordionTab } from "primereact/accordion";

const Declaration = ({
  formik,
  disableInput = false,
  businessColor = BUSINESS_LINE_COLORS.DEFAULT,
}) => {
  const { i18n, t } = useTranslation();
  const currentLanguageCode = i18n.language || "en";
  const showRTL = currentLanguageCode === "ar";
  const [isPoliticallyExposed, setIsPoliticallyExposed] = useState(false);
  const [isRoyalFamily, setIsRoyalFamily] = useState(false);
  const [isRelatedParty, setIsRelatedParty] = useState(false);
  const [politicalValue, setPoliticalValue] = useState("No");
  const [royalValue, setRoyalValue] = useState("No");
  const [relatedValue, setRelatedValue] = useState("No");
  const dispatch = useDispatch();
  const [accordion, toggleAccordion] = useState(false);

  const handleAccordion = (bool) => {
    toggleAccordion(bool);
  };

  const contentsArray = [
    "declaration.Political_content_1",
    "declaration.Political_content_2",
    "declaration.Political_content_3",
  ];

  const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
  };

  useEffect(() => {
    if (
      formik.values.PoliticallyExposed === "Yes" ||
      formik.values.PoliticallyExposed === "Yes-Part" ||
      formik.values.RelatedParty === "Yes" ||
      formik.values.RoyalMember === "Yes"
    ) {
      dispatch(setHasExposure(true));
    }
    if (
      formik.values.PoliticallyExposed === "No" &&
      formik.values.RelatedParty === "No" &&
      formik.values.RoyalMember === "No"
    ) {
      dispatch(setHasExposure(false));
    }
  }, [formik.values.PoliticallyExposed, formik.values.RelatedParty, formik.values.RoyalMember]);

  return (
    <DeclarationWrapper businessColor={businessColor}>
      <div className="conatiner Acc-det">
        <Accordion
          onTabOpen={() => handleAccordion(true)}
          onTabClose={() => handleAccordion(false)}
          activeIndex={1}
        >
          <AccordionTab
            tabIndex={0}
            header={
              <React.Fragment>
                <div className="flex-container">
                  <React.Fragment>
                    <div className="header-flex">
                      <div className="Heading-dec w-100">
                        <div className="head-icon"></div>
                        {i18n.t("declaration.title")}
                      </div>
                      <div className="Icon-Div">
                        {accordion ? (
                          <i className="pi pi-chevron-up accordianIcon up-acc"></i>
                        ) : (
                          <i className="pi pi-chevron-down accordianIcon down-acc"></i>
                        )}
                      </div>
                    </div>
                  </React.Fragment>
                </div>
              </React.Fragment>
            }
          >
            <div className="container">
              <div className="row">
                {/* <div className="col-md-12 Heading-dec">{i18n.t("declaration.title")}</div> */}
                <div className="col-md-12">
                  <div className="Subheading d-flex gap-2 align-items-center">
                    {i18n.t("declaration.ques1")}
                    <TooltipButton
                      title={t("declaration.Political_head")}
                      contents={contentsArray}
                    />
                  </div>
                  <div className="d-flex mt-2">
                    <div className="field-radiobutton mx-2">
                      <RadioButton
                        inputId="insure2"
                        name="PoliticallyExposed"
                        value="No"
                        onChange={formik.handleChange}
                        checked={formik.values.PoliticallyExposed === "No"}
                        disabled={disableInput}
                      />
                      <label htmlFor="insure2" className="mx-2">
                        {i18n.t("PERSONAL_DETAIL.NO")}
                      </label>
                    </div>
                    <div className="field-radiobutton mx-2">
                      <RadioButton
                        inputId="insure"
                        name="PoliticallyExposed"
                        value="Yes"
                        onChange={formik.handleChange}
                        checked={formik.values.PoliticallyExposed === "Yes"}
                        disabled={disableInput}
                      />
                      <label htmlFor="insure" className="mx-2">
                        {i18n.t("PERSONAL_DETAIL.YES")}
                      </label>
                    </div>

                    <div className="field-radiobutton mx-2">
                      <RadioButton
                        inputId="insure"
                        name="PoliticallyExposed"
                        value="Yes-Part"
                        onChange={formik.handleChange}
                        checked={formik.values.PoliticallyExposed === "Yes-Part"}
                        disabled={disableInput}
                      />
                      <label htmlFor="insure" className="mx-2">
                        {i18n.t("declaration.opt1")}
                      </label>
                    </div>
                  </div>
                  <hr className="visa-hr" />
                  {formik.values.PoliticallyExposed === "Yes" ? (
                    <>
                      <div className="row">
                        <div className="col-md-6 mt-2">
                          <div className="Dec-Input">
                            <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                              <InputText
                                name="PepOccupation"
                                value={formik.values.PepOccupation}
                                onChange={formik.handleChange}
                                disabled={disableInput}
                              />
                              <label>{i18n.t("declaration.occupation")}</label>
                            </span>
                            {getFormErrorMessage("PepOccupation")}
                          </div>
                        </div>

                        <div className="col-md-6 mt-2">
                          <div className="Dec-Input">
                            <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                              <InputText
                                name="Rank"
                                value={formik.values.Rank}
                                onChange={formik.handleChange}
                                disabled={disableInput}
                              />
                              <label>{i18n.t("declaration.rank")}</label>
                            </span>
                            {getFormErrorMessage("Rank")}
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {formik.values.PoliticallyExposed === "Yes-Part" ? (
                    <>
                      <div className="row">
                        <div className="col-md-6 mt-2">
                          <div className="Dec-Input">
                            <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                              <InputText
                                name="Relevant"
                                value={formik.values.Relevant}
                                onChange={formik.handleChange}
                                disabled={disableInput}
                              />
                              <label>{i18n.t("declaration.relevant_name")}</label>
                            </span>
                            {getFormErrorMessage("Relevant")}
                          </div>
                        </div>

                        <div className="col-md-6 mt-2">
                          <div className="Dec-Input">
                            <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                              <InputText
                                name="Employer"
                                value={formik.values.Employer}
                                onChange={formik.handleChange}
                                disabled={disableInput}
                              />
                              <label>{i18n.t("declaration.employer")}</label>
                            </span>
                            {getFormErrorMessage("Employer")}
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-md-6 mt-2">
                          <div className="Dec-Input">
                            <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                              <InputText
                                name="PepOccupation"
                                value={formik.values.PepOccupation}
                                onChange={formik.handleChange}
                                disabled={disableInput}
                              />
                              <label>{i18n.t("declaration.occupation")}</label>
                            </span>
                            {getFormErrorMessage("PepOccupation")}
                          </div>
                        </div>

                        <div className="col-md-6 mt-2">
                          <div className="Dec-Input ">
                            <span className={"p-float-label" + (showRTL ? " ar" : "")}>
                              <InputText
                                name="Rank"
                                value={formik.values.Rank}
                                onChange={formik.handleChange}
                                disabled={disableInput}
                              />
                              <label>{i18n.t("declaration.rank")}</label>
                            </span>
                            {getFormErrorMessage("Rank")}
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {/* <div className="row">
					<div className="col-md-12 mt-4">
						<div className="Subheading">
							{i18n.t("declaration.ques2")}
						</div>
						<div className="d-flex mt-2">
							<div className="field-radiobutton mx-2">
								<RadioButton
									inputId="insure2"
									name="RoyalMember"
									value="No"
									onChange={formik.handleChange}
									checked={formik.values.RoyalMember === "No"}
									disabled={disableInput}
								/>
								<label htmlFor="insure2" className="mx-2">
									{i18n.t("PERSONAL_DETAIL.NO")}
								</label>
							</div>
							<div className="field-radiobutton mx-2">
								<RadioButton
									inputId="insure"
									name="RoyalMember"
									value="Yes"
									onChange={formik.handleChange}
									checked={formik.values.RoyalMember === "Yes"}
									disabled={disableInput}
								/>
								<label htmlFor="insure" className="mx-2">
									{i18n.t("PERSONAL_DETAIL.YES")}
								</label>
							</div>
						</div>
						<hr className="visa-hr" />
					</div>
				</div> */}
              <div className="row">
                <div className="col-md-12 mt-4">
                  <div className="Subheading d-flex gap-2 align-items-center flex-nowrap">
                    {i18n.t("declaration.ques3")}
                    <TooltipButton
                      title={t("declaration.Related_head")}
                      content={t("declaration.Related_content")}
                    />
                  </div>
                  <div className="d-flex mt-2">
                    <div className="field-radiobutton mx-2">
                      <RadioButton
                        inputId="insure2"
                        name="RelatedParty"
                        value="No"
                        onChange={formik.handleChange}
                        checked={formik.values.RelatedParty === "No"}
                        disabled={disableInput}
                      />
                      <label htmlFor="insure2" className="mx-2">
                        {i18n.t("PERSONAL_DETAIL.NO")}
                      </label>
                    </div>
                    <div className="field-radiobutton mx-2">
                      <RadioButton
                        inputId="insure"
                        name="RelatedParty"
                        value="Yes"
                        onChange={formik.handleChange}
                        checked={formik.values.RelatedParty === "Yes"}
                        disabled={disableInput}
                      />
                      <label htmlFor="insure" className="mx-2">
                        {i18n.t("PERSONAL_DETAIL.YES")}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </AccordionTab>
        </Accordion>
      </div>
    </DeclarationWrapper>
  );
};

export default Declaration;
